module.exports = __webpack_public_path__ + "img/honor-right-2-4.ac14869d.jpg";